import { InfoSet } from "../InfoSets/InfoSet";
import { HashSet } from "../Utils/HashSet";
import { IfEntry, IfTable } from "../InfoSets/IfTable";
import { Link } from "../Core/Link";
import { VlanEntry, VlanTable } from "../InfoSets/VlanTable";
import { Dictionary } from "../Utils/Dictionary";
import { Device } from "../Core/Device";
import { StpPortEntry, StpPortTable } from "../InfoSets/StpPortTable";
import { BridgePortFdbTable } from "../InfoSets/BridgePortFdbTable";
import { FdbTable } from "../Core/FdbTable";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface BridgePortEntryJsonWrapper {
//	bridge_port_entry: BridgePortEntryJson;
//}

//export interface BridgePortEntryJson {
//    index: string;
//    if_index: string;
//	name: string;
//    vlan_index: string;
//    voice_vlan_index: string;
//    lag: string;
//    vlan_trunk: string;
//    isl: string;
//}

export class BridgePortEntry implements ObjectSerializer {
	//public static FromJson(json: BridgePortEntryJson): BridgePortEntry {
	//	var result = new BridgePortEntry(parseInt(json.index));

 //       if (json.if_index !== undefined)
 //           result.IfIndex = parseInt(json.if_index);
 //       if (json.name !== undefined)
 //           result.Name = json.name;
 //       if (json.vlan_index !== undefined)
 //           result.VlanIndex = parseInt(json.vlan_index);
 //       if (json.voice_vlan_index !== undefined)
 //           result.VoiceVlanIndex = parseInt(json.voice_vlan_index);
 //       if (json.lag !== undefined)
 //           result.IsLagPort = StringUtils.ParseBool(json.lag);
 //       if (json.vlan_trunk !== undefined)
 //           result.IsVlanTrunk = StringUtils.ParseBool(json.vlan_trunk);
 //       if (json.isl !== undefined)
 //           result.IsISL = StringUtils.ParseBool(json.isl);

	//	return result;
	//}

	public Index: number;

	public IfIndex: number;
	public get HasIfIndex(): boolean {
		return this.IfIndex >= 0;
	}

	public Name: string;
	public get HasName() {
		return !!this.Name;
	}

	public get DisplayName(): string {
		var displayName = "";
		if (this.HasName)
			displayName = this.Name;
		else {
			if (this.IfEntry != null) {
				if (this.IfEntry.PhysicalIfEntry != null)
					displayName = this.IfEntry.PhysicalIfEntry.DisplayName;
				else
					displayName = this.IfEntry.DisplayName;
			}
			else
				displayName = this.Index.toString();
		}
		return (displayName);
	}

	// VLAN Configuration
	public VlanIndex: number;
	public get HasVlanIndex(): boolean {
		return this.VlanIndex >= 0;
	}

	public VoiceVlanIndex: number
	public get HasVoiceVlanIndex(): boolean {
		return this.VoiceVlanIndex >= 0;
	}

	public IsLagPort: boolean // BridgePort is configured in a LAG (link-aggregation)
	public IsISL: boolean // Inter-Switch-Link (ISL)

	public IsVlanTrunk: boolean // Trunking (tagging) MULTIPLE VLANs on this BridgePort

	public TrunkedVLANs: HashSet<number>;
	public get HasTrunkedVLANs(): boolean {
		if (!this.IsVlanTrunk)
			return false;
		if (this.TrunkedVLANs.Count <= 0)
			return false;
		return true;
	}

	public TrunkedVLANsToString(): string {
		var trunkedVLANs = '';

		var isFirst = true;
		this.TrunkedVLANs.ForEach((vlanIndex) => {
			if (!isFirst)
				trunkedVLANs += ",";
			trunkedVLANs += vlanIndex.toString();
			isFirst = false;
		});
			
		return trunkedVLANs;
	}
	public TrunkedVLANsString: string;
	public get HasTrunkedVLANsString() {
		return !!this.TrunkedVLANsString;
	}

	public GetConnectedDevices(): string {
		var connectedDevices = '';

		var ifEntry:IfEntry = this.PhysicalIfEntry;

		if (ifEntry != null) {
			var link: Link = ifEntry.Link;
			if ((link != null) && link.HasLinkMembers) {
				link.LinkMembers.ForEach((linkMember) => {
					if (!linkMember.HasDevice)
						return;

					if (linkMember.HasIfEntry) {
						if (linkMember.IfEntry == ifEntry)
							return;
					}

					if (connectedDevices.length > 0)
						connectedDevices += ", ";

					connectedDevices += linkMember.DisplayName;
				});
			}
		}

		return connectedDevices;
	}

	public ConnectedDevices: string;
	public get HasConnectedDevices() {
		return !!this.ConnectedDevices;
	}

	// CACHE
	public IfEntry: IfEntry;
	public get PhysicalIfEntry(): IfEntry {
		if (this.IfEntry)
			return (this.IfEntry.PhysicalIfEntry);
		return null;
	}

	public VlanEntry: VlanEntry;
	public get HasVlanEntry(): boolean {
		return this.VlanEntry ? true : false;
	}

	constructor(bpIndex?: number) {
		this.Index = bpIndex;
		this.IfIndex = -1;
		this.Name = '';

		this.VlanIndex = -1;
		this.VlanEntry = null;
		this.VoiceVlanIndex = -1;

		this.IsLagPort = false;
		this.IsISL = false;
		this.IsVlanTrunk = false;
		this.TrunkedVLANs = new HashSet<number>();

		this.TrunkedVLANsString = '';
		this.ConnectedDevices = '';

		this.IfEntry = null;
	}
//export interface BridgePortEntryJson {
//    index: string;
//    if_index: string;
//	name: string;
//    vlan_index: string;
//    voice_vlan_index: string;
//    lag: string;
//    vlan_trunk: string;
//    isl: string;
//}

	public Write(obj: any, context: any): void {
		obj.bridge_port_entry = {};
		obj = obj.bridge_port_entry;

		obj.index = ValueEncoder.EncodeInteger(this.Index);

		if (this.HasIfIndex)
			obj.if_index = ValueEncoder.EncodeInteger(this.IfIndex);

		if (this.HasName)
			obj.name = this.Name;

		if (this.HasVlanIndex)
			obj.vlan_index = ValueEncoder.EncodeInteger(this.VlanIndex);

		if (this.HasVoiceVlanIndex)
			obj.voice_vlan_index = ValueEncoder.EncodeInteger(this.VoiceVlanIndex);

		obj.lag = ValueEncoder.EncodeBoolean(this.IsLagPort);

		obj.vlan_trunk = ValueEncoder.EncodeBoolean(this.IsVlanTrunk);

		obj.isl = ValueEncoder.EncodeBoolean(this.IsISL);

		if (this.HasTrunkedVLANsString)
			obj.trunked_vlans = this.TrunkedVLANsString;

		if (this.HasConnectedDevices)
			obj.connected_devices = this.ConnectedDevices;

        obj.if_entry = this.IfEntry;
	}

	public Read(obj: any, context: any): void {
		if (!obj.bridge_port_entry)
			throw new Error();
		obj = obj.bridge_port_entry;

		if (obj.index !== undefined)
			this.Index = ValueEncoder.DecodeInteger(obj.index);

		if (obj.if_index !== undefined)
			this.IfIndex = ValueEncoder.DecodeInteger(obj.if_index);

		if (obj.name !== undefined)
			this.Name = obj.name;

		if (obj.vlan_index !== undefined)
			this.VlanIndex = ValueEncoder.DecodeInteger(obj.vlan_index);

		if (obj.voice_vlan_index !== undefined)
			this.VoiceVlanIndex = ValueEncoder.DecodeInteger(obj.voice_vlan_index);

		if (obj.lag !== undefined)
			this.IsLagPort = ValueEncoder.DecodeBoolean(obj.lag);

		if (obj.vlan_trunk !== undefined)
			this.IsVlanTrunk = ValueEncoder.DecodeBoolean(obj.vlan_trunk);

		if (obj.isl !== undefined)
			this.IsISL = ValueEncoder.DecodeBoolean(obj.isl);

		if (obj.trunked_vlans !== undefined)
			this.TrunkedVLANsString = obj.trunked_vlans;

		if (obj.connected_devices !== undefined)
			this.ConnectedDevices = obj.connected_devices;

        if (obj.if_entry !== undefined)
            this.IfEntry = obj.if_entry;
	}
}

export class BridgePortTable extends InfoSet {
	//public static FromJson(json: InfoSetEntriesJson<BridgePortEntryJsonWrapper>, device: Device): BridgePortTable {
	//	var result = new BridgePortTable(device);

	//	json.entries.forEach((jsonEntry) => {
	//		result.AddEntry(BridgePortEntry.FromJson(jsonEntry.bridge_port_entry));
	//	});

	//	return result;
	//}

	public ToArray():BridgePortEntry[] {
		return this._bpTable.Values().Values;
	}

	private _bpTable: Dictionary<number, BridgePortEntry>;

	constructor(device: Device) {
		super(device);
		this._bpTable = new Dictionary<number, BridgePortEntry>();
	}

	public Add(bpIndex: number): BridgePortEntry {
		var bpEntry: BridgePortEntry = this._bpTable.Item(bpIndex);
			
		if(!bpEntry) {
			bpEntry = new BridgePortEntry(bpIndex);
			this._bpTable.Add(bpIndex, bpEntry);
		}

		return bpEntry;
	}

	public AddEntry(bpEntry: BridgePortEntry): void {
		if (!bpEntry)
			return;

		if (bpEntry.Index < 0)
			return;

		this._bpTable.Remove(bpEntry.Index);
		this._bpTable.Add(bpEntry.Index, bpEntry);
	}

	public Clear():void {
		this._bpTable.Clear();
	}

	public get Count():number {
		return this._bpTable.Count;
	}

	public Find(bpIndex:number): BridgePortEntry {
		return this._bpTable.Item(bpIndex);
	}

	public FindByIfIndex(ifIndex: number): BridgePortEntry {
		var foundEntry: BridgePortEntry = null;

		this._bpTable.Some((pair) => {
			if (pair.Value.IfIndex == ifIndex) {
				foundEntry = pair.Value;
				return true;
			}
		});

		return foundEntry;
	}

	public RemoveByIndex(bpIndex:number):boolean{
		return this._bpTable.Remove(bpIndex);
	}

	public Remove(bpEntry: BridgePortEntry): boolean{
		return bpEntry ? this._bpTable.Remove(bpEntry.Index) : false;
	}

	public ForEach(callbackfn: (value: BridgePortEntry, index: number, array: BridgePortEntry[]) => void, thisArg?: any): void {
		this._bpTable.Values().ForEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (value: BridgePortEntry, index: number, array: BridgePortEntry[]) => boolean, thisArg?: any): boolean {
		return this._bpTable.Values().Some(callbackfn, thisArg);
	}

	public ClearIfEntryCache(): void {
		this._bpTable.ForEach((pair) => {
			if (pair.Value.IfEntry) {
				pair.Value.IfEntry.BridgePortEntry = null;
				pair.Value.IfEntry = null;
			}
		});
	}

	public RebuildIfEntryCache():void {
		this.ClearIfEntryCache();

		if (this.Device.HasIfTable) {
			var ifTable: IfTable = this.Device.IfTable;
			var ifEntry: IfEntry = null;

			this._bpTable.ForEach((pair) => {
				ifEntry = ifTable.Find(pair.Value.IfIndex);
				if (ifEntry != null) {
					ifEntry.BridgePortEntry = pair.Value;
					ifEntry.BridgePortIndex = pair.Value.Index;
					pair.Value.IfEntry = ifEntry;
				}
			});
		}
	}

	public ClearVlanEntryCache(): void {
		this._bpTable.ForEach((pair) => {
			pair.Value.VlanEntry = null;
		});
	}

	public RebuildVlanEntryCache():void	{
		this.ClearVlanEntryCache();

		if (this.Device.HasVlanTable) {
			var vlanTable:VlanTable = this.Device.VlanTable;

			this._bpTable.ForEach((pair) => {
				if (pair.Value.HasVlanIndex) {
					pair.Value.VlanEntry = vlanTable.Find(pair.Value.VlanIndex);
				}
			});
		}
	}

	public ClearVlanInfo(): void {
		this._bpTable.ForEach((pair) => {
			pair.Value.VlanIndex = -1;
			pair.Value.VlanEntry = null;
		});

		this.ClearVlanTrunkInfo();
	}

	public ClearVoiceVlanInfo(): void {
		this._bpTable.ForEach((pair) => {
			pair.Value.VoiceVlanIndex = -1;
		});
	}

	public HasVlanInfo():boolean {
		// CHECK if the TRUNKED VLAN information has been REBUILT/CACHED on BridgePort object
		if (this._bpTable.Some((pair) => {
			if (pair.Value.IsVlanTrunk && pair.Value.TrunkedVLANs.Count <= 0)
				return true;
		}))
			return false;

		return this._bpTable.Some((pair) => {
			return pair.Value.HasVlanIndex;
		});
	}

	public SyncVlanInfo():void {
		if (!this.Device || !this.Device.HasVlanTable)
			return;
			
		var vlanTable:VlanTable = this.Device.VlanTable;

		vlanTable.ForEach((vlanEntry) => {
			var untaggedPorts: HashSet<number> = vlanEntry.UntaggedPorts.ToPortSet();

			untaggedPorts.ForEach((port) => {
				var bpEntry: BridgePortEntry = this.Find(port);
				if (bpEntry) {
					// MARK the BRIDGEPORT with the VLAN that is transmitted in the CLEAR (UNTAGGED)
					bpEntry.VlanIndex = vlanEntry.Index;
					bpEntry.VlanEntry = vlanEntry;
				}
			});
		});

		this.SyncVlanTrunkInfo();
	}

	private ClearVlanTrunkInfo(): void {
		this._bpTable.ForEach((pair) => {
			pair.Value.IsVlanTrunk = false;
			pair.Value.TrunkedVLANs.Clear();
		});
	}

	private SyncVlanTrunkInfo():void {
		if (!this.Device || !this.Device.HasVlanTable)
			return;

		// RESET
		this.ClearVlanTrunkInfo();

		var vlanTable:VlanTable = this.Device.VlanTable;
		var vlanIndex = -1;

		vlanTable.ForEach((vlanEntry) => {
			var taggedPorts: HashSet<number> = vlanEntry.EgressPorts.ToPortSet();
			var untaggedPorts: HashSet<number> = vlanEntry.UntaggedPorts.ToPortSet();
			vlanIndex = vlanEntry.Index;

			taggedPorts.ForEach((bpIndex) => {
				if (untaggedPorts.Contains(bpIndex))
					return;

				var bpEntry: BridgePortEntry = this.Find(bpIndex);
				if (bpEntry == null)
					return;

				if (!bpEntry.TrunkedVLANs.Contains(vlanIndex))
					bpEntry.TrunkedVLANs.Add(vlanIndex);

				// CHECK to see if we have multiple VLANs tagged on this port
				if (bpEntry.TrunkedVLANs.Count > 1) {
					bpEntry.IsVlanTrunk = true;
				}
				else if (bpEntry.TrunkedVLANs.Count == 1) {
					// CHECK to see if the TRUNKED VLANs are DIFFERENT than the NATIVE VLAN
					if (bpEntry.HasVlanIndex && !bpEntry.TrunkedVLANs.Contains(bpEntry.VlanIndex))
						bpEntry.IsVlanTrunk = true;
				}
			});
		});
	}

	private ClearIslInfo(): void {
		this._bpTable.ForEach((pair) => {
			pair.Value.IsISL = false;
		});
	}

	public RebuildIslInfo():void {
		this.ClearIslInfo();

		var stpTable: StpPortTable = null;
		var stpEntry: StpPortEntry = null;

		var bpFdbTable: BridgePortFdbTable = null;
		var fdbTable: FdbTable = null;

		var remoteDevice: Device = null;

		// GET the SPANNING-TREE table (for the whole device)
		if (this.Device.HasStpPortTable)
			stpTable = this.Device.StpPortTable;

		// GET the FDB database table (for the whole device)
		if (this.Device.HasBridgePortFdbTable)
			bpFdbTable = this.Device.BridgePortFdbTable;

		this._bpTable.ForEach((pair) => {
			var bpEntry: BridgePortEntry = pair.Value;

			// ****************************************************
			// STEP 1 - CHECK VLANs/LAG/SPANNING-TREE configuration
			if (bpEntry.IsVlanTrunk)
				bpEntry.IsISL = true;
			else if (bpEntry.IsLagPort)
				bpEntry.IsISL = true;
			else {
				// IF the PORT has VALID spanning-tree information; ISL=TRUE
				if (stpTable != null) {
					stpEntry = stpTable.Find(bpEntry.Index);
					if (stpEntry != null)
						bpEntry.IsISL = true;
				}
			}

			// ****************************************************
			// STEP 2: Check the FORWARDING DB
			// NOTE: If the BridgePort has a FORWARDING DB; CHECK to see if we are forwarding to NETWORK DEVICES
			if (bpFdbTable != null) {
				fdbTable = bpFdbTable.Find(bpEntry.Index);
				if (fdbTable != null) {
					// RESET - the forwarding database is the most reliable at setting the state of ISL
					/*
					bpEntry.IsISL = false;

					foreach (FdbEntry fdbEntry in fdbTable)
					{
						remoteDevice = fdbEntry.RemoteDevice;
						if (remoteDevice != null)
						{
							if (remoteDevice.IsNetworkDevice())
							{
								bpEntry.IsISL = true;
								break;
							}
						}
					}
						*/
				}
			}
		});
	}

	public Write(obj: any, context: any): void {
		obj.bp_info = {};
		obj = obj.bp_info;

		obj.entries = [];
		ObjSerUtils.WriteObjSerCollection(obj.entries, this._bpTable.Values(), context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.bp_info)
			throw new Error();
		obj = obj.bp_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((value: any) => {
				let entry = new BridgePortEntry();
				entry.Read(value, context);
				this.AddEntry(entry);
			}, this);
		}
	}
}
